import { render, staticRenderFns } from "./TestInfoButton.vue?vue&type=template&id=0ab87e54&scoped=true"
import script from "./TestInfoButton.vue?vue&type=script&lang=js"
export * from "./TestInfoButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab87e54",
  null
  
)

export default component.exports